import { Feather } from '@expo/vector-icons';
import { FirebaseAuthTypes, signOut as signOutMobile } from '@react-native-firebase/auth';
import { router } from 'expo-router';
import { Auth, signOut as signOutWeb } from 'firebase/auth';
import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useDeleteUser } from '@/api/hooks/authQueryHooks';
import Text from '@/components/Text';
import { useAuth } from '@/contexts/authContext';
import { useBottomSheet } from '@/contexts/bottomSheetContext';
import { useMeFavorites } from '@/contexts/favoritesContext';
import { auth } from '@/firebaseConfig';
import { i18n } from '@/utils/i18n';

import BrandedButton from '../buttons/BrandedButton';
import CloseButton from '../buttons/CloseButton';
import { useDeepLinkStore } from '@/deepLinks/deepLinkStore';

const DeleteAccountBottomSheet = () => {
  const { state, dispatch, clearCurrentUser } = useAuth();
  const { clearFavorites } = useMeFavorites();
  const { dispatch: manageSheet } = useBottomSheet();
  const { mutateAsync: deleteUser, isPending } = useDeleteUser();
  const { clearPendingLink } = useDeepLinkStore();

  //Locales
  const title = i18n.t('settings.delete_account.title');
  const message = i18n.t('settings.delete_account.message');
  const action = i18n.t('settings.delete_account.action');

  const onUserDeleted = async () => {
    if (state.user?.user.id)
      try {
        deleteUser(
          {
            userId: state.user?.user.id
          },
          {
            onSuccess: async () => {
              dispatch({ type: 'SIGN_OUT' });
              clearCurrentUser();
              if (Platform.OS === 'web') {
                await signOutWeb(auth() as Auth);
              } else {
                await signOutMobile(auth() as FirebaseAuthTypes.Module);
              }
              clearFavorites();
              clearPendingLink();
              manageSheet({ type: 'SET_VISIBLE', setVisible: false });
              if (router.canDismiss()) router.dismissAll();
              router.push('/');
            },
            onError: (e) => {
              console.error(e);
            }
          }
        );
      } catch (e) {
        console.error(e);
      }
  };

  const onCloseTap = () => {
    manageSheet({ type: 'SET_VISIBLE', setVisible: false });
  };

  return (
    <SafeAreaView style={styles.flexOne} edges={['bottom']}>
      <View style={styles.container}>
        <CloseButton style={styles.closeBtn} onCloseTap={onCloseTap} />

        <Text style={styles.titleText} fontWeight="500">
          {title}
        </Text>
        <View style={styles.logOutCircle}>
          <Feather name="trash-2" size={35} color="black" />
        </View>
        <Text style={styles.messageText} fontWeight="450">
          {message}
        </Text>
        <BrandedButton style={styles.logOutBtn} loading={isPending} onPress={onUserDeleted}>
          {action}
        </BrandedButton>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  container: {
    backgroundColor: 'white',
    paddingHorizontal: 18,
    flexDirection: 'column',
    alignItems: 'center',
    rowGap: 25
  },

  closeBtn: {
    alignSelf: 'flex-start'
  },

  titleText: {
    color: 'black',
    fontSize: 18,
    textAlign: 'center'
  },

  messageText: {
    color: 'black',
    fontSize: 14,
    textAlign: 'center'
  },

  logOutCircle: {
    backgroundColor: 'white',
    height: 100,
    width: 100,
    borderRadius: 50,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.12,
    shadowRadius: 10,
    elevation: 5,
    justifyContent: 'center',
    alignItems: 'center'
  },

  logOutBtn: {
    backgroundColor: '#B41C1C',
    paddingHorizontal: 20,
    marginTop: 25,
    width: '100%'
  }
});

export default DeleteAccountBottomSheet;
